import styled from 'styled-components'

export const ContentBack = styled.div<{ $alignment?: string }>`
  display: flex;
  margin-bottom: 10px;
  align-items: flex-start;
  width: 90%;
  cursor: pointer;
  align-self: ${(props) => `${props.$alignment}`};

  .arrow-right-back {
    background-image: url('/assets/icons/arrow-right-back.svg');
    background-size: cover;
    width: 23px;
    height: 22px;
    margin-right: 6px;
  }
  p {
    color: #8e92bc;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
  }
`
